<template>
  <div id="app">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
    <!-- <NavMenu v-if="!isLoginPage"></NavMenu> -->
    <!-- 使用命名视图 -->
    <!-- 显示侧边栏视图 -->
    <main>
      <!-- 主内容区域 -->
      <router-view></router-view>
      <!-- 显示主视图 -->
    </main>
    <consultation-bubble />
    <!-- <FooterComp></FooterComp> -->
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import NavMenu from "./components/NavMenu.vue";
import ConsultationBubble from "./components/ConsultationBubble.vue";
import { updateDocumentMetadata } from "./utils/documentMetadata";

export default {
  name: "App",
  components: {
    HelloWorld,
    NavMenu,
    ConsultationBubble,
  },
  data() {
    return {
      // isLoginPage: false,
    };
  },
  computed: {
    isLoginPage() {
      return this.$route.path === "/login";
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) { updateDocumentMetadata(route, this.$i18n.locale); },
    },
    "$i18n.locale"(locale) { updateDocumentMetadata(this.$route, locale); },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

}
</style>
